import { render, staticRenderFns } from "./travelList.vue?vue&type=template&id=331570ca&scoped=true&"
import script from "./travelList.vue?vue&type=script&lang=js&"
export * from "./travelList.vue?vue&type=script&lang=js&"
import style0 from "./travelList.vue?vue&type=style&index=0&id=331570ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331570ca",
  null
  
)

export default component.exports